/**
 * Admin FICA pipeline — /admin/fica (route shell).
 *
 * Screen impl in `./fica-screen.tsx`, lazy-loaded. Admin-gated surface (behind
 * the /admin layout) — never on a trustee's path, so it stays out of the
 * initial bundle.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/fica')({
  component: lazyRouteComponent(() => import('./fica-screen'), 'AdminFicaPage'),
});
